/** @format */

import React, {useState} from 'react';

import {GridSelect, Icon, Input} from '@sttark/design-system';
import {InputWithErrorHandler} from 'frontier-form';
import {ConditionalButton} from 'frontier-utilities';
import {parseString} from 'superagent/lib/client';
import {SIZE_STATUS_APPROVED, SIZE_STATUS_INSTOCK} from 'frontier-constants';

export default function CustomShapeSelect({dies, selectedDie, onChange}) {
    const [dieSearch, setDieSearch] = useState('');

    if (dies.length > 0) {
        const filteredDies = dies.filter(({id, status_id}) => {
            if (!dieSearch || dieSearch.length === 0) {
                return status_id === SIZE_STATUS_INSTOCK;
            }
            return id.toString() === dieSearch; // exact match only
        });
        return (
            <>
                <div className="mb-4">
                    <div>
                        <Input
                            label="Search By Die ID"
                            className="form-control"
                            value={dieSearch}
                            onChange={setDieSearch}
                        />
                    </div>
                </div>

                <ConditionalButton enabled={filteredDies.length === 0}>
                    <p>No sizes found with that ID</p>
                    <GridSelect
                        options={filteredDies.map(d => ({...d, value: d.id}))}
                        value={selectedDie?.id}
                        onChange={onChange}>
                        {({option: die, selected, handleClick}) => {
                            const url =
                                process.env.AWS_CUSTOM_SHAPE_SIZE_SVG_CONTAINER_URL +
                                '/' +
                                die.s3key;
                            return (
                                <>
                                    <button
                                        style={{
                                            maxWidth: '200px'
                                        }}
                                        className={`grid-select--button ratio ratio-4x3 border-all`}
                                        aria-pressed={selected}
                                        onClick={handleClick.bind(this, die.id)}>
                                        <span className="d-flex p-1 align-items-center justify-content-center">
                                            {die.s3key && (
                                                <img
                                                    alt=""
                                                    src={url}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '100%'
                                                    }}
                                                />
                                            )}
                                        </span>
                                        {selected && (
                                            <span className="grid-select--button--selected">
                                                <Icon name="Check" medium />
                                            </span>
                                        )}
                                    </button>
                                    <div>#{die.id}</div>
                                    <div>{die.label}</div>
                                    {die.s3key && (
                                        <a href={url} target="_blank">
                                            Download
                                        </a>
                                    )}
                                </>
                            );
                        }}
                    </GridSelect>
                </ConditionalButton>
            </>
        );
    } else {
        return <p>No sizes were found.</p>;
    }
}
